<template>
    <ui-link class="user-nft" v-bind:to="route">
        <template>
            <div class="user-nft__image">
                <img v-show="images.original && !imgError" class="user-nft__image__img"
                    v-bind:src="images.w320"
                    v-bind:srcset="`${images.w320} 320w, ${images.w640} 640w, ${images.w960} 960w`"
                    v-bind:style="{ backgroundImage: `url(${images.i})` }"
                    sizes="(max-width: 480px) 220px, 280px"
                    v-on:error="imgError = true"
                >

                <div class="user-nft__image__broken" v-if="imgError">
                    <icon-broken />
                </div>

                <div v-else class="nft-preview__image skeleton"/>
            </div>

            <footer class="user-nft__footer">
                <div class="user-nft__name" v-if="name" v-text="name"/>
                <div class="nft-preview__meta" v-if="itemCount > 0" v-text="$t('nft.item.preview.index', {
                    index: index + 1,
                    total: itemCount,
                })"/>
                <div v-else class="nft-preview__meta">
                    {{ $t('common.nft_item') }}
                </div>
            </footer>
        </template>
    </ui-link>
</template>

<script>
import IconBroken from '@img/icons/tonscan/image-broken.svg?vue';

export default {
    props: {
        address: String,
        index: Number,
        itemCount: Number,
        isReloading: Boolean,
        invalid: {
            type: Boolean,
            default: false,
        },
        name: {
            type: String,
            default: '¯\\_(ツ)_/¯',
        },
        images: {
            type: Object,
            default: () => ({}),
        },
    },

    data() {
        return {
            imgError: false,
        };
    },

    computed: {
        route() {
            return {
                name: 'nft',
                params: {
                    address: this.address,
                    skeletonHint: 'item',
                },
            };
        },
    },

    components: {
        IconBroken,
    },
};
</script>

<style lang="scss">
.nft-preview-footer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
}
.nft-preview-error {
    border-radius: 0.52rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    box-shadow: 0 0 0 1px var(--card-border-color) inset;
    background: var(--nft-preview-error-card-background);
    &__info {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        flex-grow: 1;
        padding-top: 12px;
        height: 100%;
    }
    &__image {
        background-color: transparent !important;
    }
    &__icon {
        width: 32px;
        margin-bottom: 16px;
        fill: currentColor;
        opacity: .8;
    }
    &__text {
        font-size: 15px;
        margin: 0 8px;
        font-weight: 500;
    }
    &__button {
        padding: 10px 12px 10px 18px;
        border-radius: 24px;
        margin-top: -1px; // optically compensate top border
        cursor: pointer;
        display: inline-flex;
        transition: .1.8s all ease;
        &:hover {
            background: rgba(0, 0, 0, 0.4);
        }
        svg {
            margin-left: -6px;
            margin-right: 6px;
            fill: currentColor;
        }
    }
}
</style>
